import {
    Box,
    Flex,
    Grid,
} from "@chakra-ui/react";

import {
    useEffect,useState
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

import PageHeader from "../Dashboard/components/PageHeader";

import AnalyticsStats from "./components/AnalyticsStats";
import GrowthChart from "./components/GrowthChart";
import FunnelAnalytics from "./components/FunnelAnalytics";
import TopRecruitsTable from "./components/TopRecruitsTable";
import CommissionLiability from "./components/CommissionLiability";
import DriverLocations from "./components/DriverLocations";
import AnalyticsSkeleton from "./components/AnalyticsSkeleton";
import {
    fetchReferredDriversAction,
    fetchReferralMilestonesAction,
    fetchPendingCommissionsAction,
    fetchPartnerPayoutsAction,
} from "../../state/actions/driverPartnerActions";

import {
    fetchDriverByIdAction,
    fetchRecruitedVehiclesAction,
} from "../../state/actions/driverActions";

const Analytics = () => {
    const dispatch =
        useDispatch();
    const [showSkeleton, setShowSkeleton] =
    useState(true);

useEffect(() => {
    const timer = setTimeout(() => {
        setShowSkeleton(false);
    }, 3000);

    return () => clearTimeout(timer);
}, []);
    const {
        driverPartner,
        referredDrivers = [],
        referralMilestones = [],
        pendingCommissions = [],
        partnerPayouts = [],
        loading,
    } = useSelector(
        state =>
            state.driverPartner
    );

    const {
        drivers: driverDetails = {},
        recruitedVehicles = [],
    } = useSelector(
        state =>
            state.driver
    );

    useEffect(() => {
        dispatch(
            fetchReferredDriversAction(
                1,
                100
            )
        );

        dispatch(
            fetchReferralMilestonesAction()
        );
         dispatch(
        fetchPendingCommissionsAction(
            1,
            100
        )
    );
        dispatch(
            fetchRecruitedVehiclesAction(
                1,
                100
            )
        );
    }, [
        dispatch,
    ]);

    useEffect(() => {
    if (driverPartner?.driver_partner_id) {
        dispatch(
            fetchPartnerPayoutsAction(
                driverPartner.driver_partner_id,
                1,
                100
            )
        );
    }
}, [
    dispatch,
    driverPartner,
]);

    useEffect(() => {
        referredDrivers
            .filter(
                recruit =>
                    recruit.driver
                        ?.driver_id
            )
            .forEach(
                recruit => {
                    dispatch(
                        fetchDriverByIdAction(
                            recruit.driver
                                .driver_id
                        )
                    );
                }
            );
    }, [
        referredDrivers,
        dispatch,
    ]);
    if (showSkeleton) {
    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <AnalyticsSkeleton />
                </Box>
            </Flex>
        </Flex>
    );
}
    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="Analytics"
                        subtitle="Monitor recruit performance, partner growth, commissions and operational insights."
                    />

                    <AnalyticsStats
                        drivers={
                            referredDrivers
                        }
                        milestones={
                            referralMilestones
                        }
                        commissions={pendingCommissions}
                        payouts={partnerPayouts}
                    />

                    {/* Growth Chart */}

                    <Box mt={8}>
                        <GrowthChart
                            drivers={
                                referredDrivers
                            }
                            milestones={
                                referralMilestones
                            }
                             commissions={pendingCommissions}
                             payouts={partnerPayouts}
                        />
                    </Box>

                    {/* Funnel + Commission */}

                    <Grid
                        mt={6}
                        gap={6}
                        templateColumns={{
                            base: "1fr",
                            lg: "1fr 1fr",
                        }}
                    >
                        <FunnelAnalytics
                            drivers={
                                referredDrivers
                            }
                            milestones={
                                referralMilestones
                            }
                        />

                        <CommissionLiability
                            milestones={
                                referralMilestones
                            }
                             commissions={pendingCommissions}
                             payouts={partnerPayouts}
                        />
                    </Grid>

                    {/* Driver Locations */}

                    <Box mt={6}>
                        <DriverLocations
                            driverDetails={Object.values(
                                driverDetails
                            )}
                        />
                    </Box>

                    {/* Top Recruits */}

                    <Box mt={6}>
                        <TopRecruitsTable
                            partner={
                                driverPartner
                            }
                            drivers={
                                referredDrivers
                            }
                            milestones={
                                referralMilestones
                            }
                             commissions={pendingCommissions}
                             payouts={partnerPayouts}
                        />
                    </Box>
                </Box>
            </Flex>
        </Flex>
    );
};

export default Analytics;